
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as Part1GuidesIconComponent } from "./part1-guides-icon.svg";

export const Part1GuidesIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <Part1GuidesIconComponent {...props} />;
};
